import { Component, OnInit } from "@angular/core";
import { EActiveTab } from "../../data-types/tabs.enum";
import { iconsLibrary } from "../../../theme/constants";

@Component({
  selector: "cowing-core-coworker-fav",
  templateUrl: "./coworker-fav.component.html",
  styleUrls: ["./coworker-fav.component.scss"],
})
export class CoworkerFavComponent implements OnInit {
  public EActiveTab = EActiveTab;
  constructor() {}
  async ngOnInit() {}

  get getHeartIcon() {
    return `${iconsLibrary.heart}`;
  }
}
